import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SuccessCard } from '../../tailwind_clearstep/SuccessCard/SuccessCard';
import { QuestionMarkIcon } from '../../svg/QuestionMarkIcon';
import Modal from '../../tailwind_common/Modal/Modal.Lazy.Wrapped';
import styles from './QuestionFeedback.css';
import ButtonWithIcon, { ButtonWithIconVariant } from '../../tailwind_common/ButtonWithIcon';
import Checkbox from '../../tailwind_common/Checkbox';
import Textarea from '../../tailwind_common/Textarea';
import Button from '../../tailwind_common/Button';
var QuestionFeedback = function (props) {
    var message = props.message, submitted = props.submitted, question = props.question, value = props.value, onUpdateValue = props.onUpdateValue, onUpdateMessage = props.onUpdateMessage;
    var t = useTranslation().t;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(false), showSuccess = _b[0], setShowSuccess = _b[1];
    var feedbackOptions = [
        t('questionFeedback.option1', 'Unclear or confusing'),
        t('questionFeedback.option2', "Doesn't apply to me"),
        t('questionFeedback.option3', 'Culturally insensitive'),
        t('questionFeedback.option4', 'Other reason'),
    ];
    var handleSubmit = function () {
        props.onSubmit();
        handleCloseModal();
        handleShowSuccess();
    };
    var handleOpenModal = function () { return setIsOpen(true); };
    var handleCloseModal = function () {
        setIsOpen(false);
        return props.onClear();
    };
    var handleShowSuccess = function () {
        setShowSuccess(true);
        setTimeout(function () { return setShowSuccess(false); }, 2000);
    };
    return (React.createElement("div", null,
        React.createElement(ButtonWithIcon, { text: t('questionFeedback.title', "This question doesn't make sense"), icon: React.createElement(QuestionMarkIcon, null), variant: ButtonWithIconVariant.Gray, onClick: handleOpenModal }),
        React.createElement(Modal, { isOpen: isOpen, className: styles.questionFeedback, onClose: handleCloseModal, title: t('questionFeedback.title', "This question doesn't make sense") || '', disableCloseOnClickOutside: !submitted },
            !submitted && (React.createElement(React.Fragment, null,
                React.createElement("h2", { id: "feedback-prompt" },
                    t('questionFeedback.prompt', 'How can we improve the question '),
                    React.createElement("span", null, 
                    // eslint-disable-next-line react/jsx-no-literals
                    "\"".concat(question, "\""))),
                React.createElement("div", { className: styles.questionFeedback__inputs, role: "group", "aria-labelledby": "feedback-prompt" },
                    feedbackOptions.map(function (option) { return (React.createElement(Checkbox, { key: option, checked: option === value, label: option, onChange: function () { return onUpdateValue(option); } })); }),
                    React.createElement(Textarea, { value: message, onChange: function (e) { return onUpdateMessage(e.target.value); }, Label: function () { return React.createElement(React.Fragment, null, t('questionFeedback.inputLabel', 'More details (optional)')); }, placeholder: t('questionFeedback.inputPlaceholder', 'Enter the reason for your selection') ||
                            '', id: "questionFeedbackTextarea" })),
                React.createElement("p", { className: styles.questionFeedback__disclaimer }, t('piError.inputInstruction', 'Do not enter personally identifiable information, e.g. Name.')),
                React.createElement("div", { className: styles.questionFeedback__buttons },
                    React.createElement(Button, { isText: true, onClick: handleCloseModal }, t('common.cancelCta', 'Cancel')),
                    React.createElement(Button, { onClick: handleSubmit, disabled: !message && !value }, t('common.submitCta', 'Submit'))))),
            submitted && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.questionFeedback__submitted },
                    React.createElement("h2", { role: "alert" }, t('questionFeedback.confirmation.header', 'Feedback received')),
                    React.createElement("p", null, t('questionFeedback.confirmation.subheader', 'We have received your feedback for this question. Thank you for helping us to improve.'))),
                React.createElement("div", { className: styles.questionFeedback__buttons },
                    React.createElement(Button, { onClick: handleCloseModal }, t('questionFeedback.confirmation.closeCta', 'Okay')))))),
        showSuccess && (React.createElement("div", { className: styles.questionFeedback__successCardWrapper },
            React.createElement(SuccessCard, null)))));
};
export default QuestionFeedback;
